import { z } from 'zod';

export const WithRecommendationsInReaderDefinition = z.object({
  series: z.array(z.object({ seriesId: z.string(), bannerCoverURI: z.string(), subtitle: z.string() })),
  bannerItemLabel: z.string(),
  bannerItemCTAText: z.string(),
});

export type WithRecommendationsInReaderDefinition = z.infer<typeof WithRecommendationsInReaderDefinition>;
